import { Outlet, useParams } from 'react-router-dom'
import NavigationBar from '../NavigationBar/NavigationBar'
import TutorialWalkthrough from 'components/TutorialWalkthrough'
import IdleTimer from 'components/layout/IdleTimer'
import SnackBar from 'components/layout/SnackBar'
import { AuthenticatedTemplate } from '@azure/msal-react'
import { useEffect } from 'react'
import { LookupProvider } from 'contexts/LookupContext'
import { Footer } from '../Footer'
import { MilestoneProvider } from 'contexts/MilestoneContext'
import { useAppContext } from 'contexts/AppContext'
import LegalContentDialog from 'pages/LegalContentDialog'

export const Content = () => {
	let { authCode } = useParams()
	const { consentGiven } = useAppContext()

	useEffect(() => {
		if (authCode && /^\d{6}$/.test(authCode)) {
			sessionStorage.setItem('authCode', authCode)
		} else {
			sessionStorage.removeItem(null)
		}
	}, [authCode])

	return (
		<>
			<LookupProvider>
				<AuthenticatedTemplate>
					<MilestoneProvider>
						<NavigationBar />
						{consentGiven && (
							<>
								<SnackBar />
								<Outlet />
								<Footer />
							</>
						)}
						<IdleTimer />
						<TutorialWalkthrough />
						<LegalContentDialog />
					</MilestoneProvider>
				</AuthenticatedTemplate>
			</LookupProvider>
		</>
	)
}
